module.exports = __webpack_public_path__ + "static/media/chokowood.57a3bf0c.png";